export default __webpack_public_path__ + "static/media/icons8-html.eb820aef.gif";